export const defaultCatalogLinks = []
export const defaultContent = {
  title: '',
  landingPageLinks: []
}

export default {
  catalogLinks: defaultCatalogLinks,
  content: defaultContent
}
